import {
  createRouter,
  createWebHistory
} from 'vue-router'
import MainLayout from '@/layout/MainLayout.vue'
import Home from '@/views/HomeView.vue'
import TextGeneration from '@/views/generation/TextGeneration.vue'
import ImageGeneration from '@/views/generation/ImageGeneration.vue'
import VideoGeneration from '@/views/generation/VideoGeneration.vue'
import Square from '@/views/square/SquareView.vue'
import Login from '@/views/LoginView.vue'
import Register from '@/views/RegisterView.vue'
import Vip from '@/views/vip/VipView.vue'
import {
  useUserStore
} from '@/stores/user'
const routes = [{
    path: '/',
    component: MainLayout,
    children: [{
        path: '',
        component: Home
      },
      {
        path: 'text',
        component: TextGeneration
      },
      {
        path: 'image',
        component: ImageGeneration
      },
      {
        path: 'video',
        component: VideoGeneration
      },
      {
        path: 'square',
        component: Square
      },
    ]
  },
  {
    path: '/vip',
    component: Vip,
    meta: {}
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/register',
    component: Register
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // 检查路由元信息中是否需要认证
  if (to.matched.some(record => record.meta.needLogin)) {
    if (!isAuthenticated()) { // 自定义的认证函数，返回true或false
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        } // 将目标路由地址作为参数传递给登录页面，登录后可重定向回该地址
      });
    } else {
      next(); // 用户已认证，放行
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});

// TODO 默认只要登陆了就行
function isAuthenticated() {
  const userStore = useUserStore()
  return userStore.isLoggedIn
}

export default router